import React from 'react';
import PropTypes from 'prop-types';
import Picture from '@deporvillage/picture-component';
import { Config, I18n, I18nContext } from '@deporvillage/utils-library-component';

import styles from './PayPalWidget.module.scss';

const DynamicWidget = ({ amount }) => {

    const elem = React.useRef(null);
    const { country, paypal, store } = React.useContext(Config);

    React.useEffect(() => {
        /* eslint-disable no-undef */
        let script = document.createElement('script');
        script.src = `https://www.paypal.com/sdk/js?client-id=${paypal.widget.clientId}&currency=${country.currency_code}&components=messages`;
        script.async = true;
        script.setAttribute('fetchpriority', 'low');
        elem.current.appendChild(script);
        /* eslint-enable no-undef */
    }, []);

    return (
        <div
            ref={elem}
            className={styles['paypal-dynamic-component']}
            data-pp-message
            data-pp-placement={'product'}
            data-pp-amount={amount}
            data-pp-buyercountry={store.code}
        />
    );
};
DynamicWidget.propTypes = {
    amount: PropTypes.number,
};

const StaticWidget = () => {

    const { translate } = React.useContext(I18nContext);
    const { paypal } = React.useContext(Config);

    return (
        <div
            className={styles['paypal-static-component']}
        >
            <Picture
                width={70}
                src={'static/product/payment/paypal.png'}
                name={translate('product_page.paypal.widget.message')}
                lazy
            />
            <div className={styles['message']}>
                <span>
                    {translate('product_page.paypal.widget.message', { terms: paypal.widget.terms })}
                </span>
                <a
                    title={translate('product_page.paypal.widget.message', { terms: paypal.widget.terms })}
                    href={translate('product_page.paypal.widget.info_url')}
                    rel={'noopener noreferrer nofollow'}
                    target={'_blank'}
                >
                    <I18n>product_page.paypal.widget.info</I18n>
                </a>
            </div>
        </div>
    );
};

const PayPalWidget = (props) => {

    const { paypal } = React.useContext(Config);
    if (!paypal.widget.enabled) return null;

    return (
        <div className={styles['paypal-widget-component']}>
            { paypal.widget.dynamic ? <DynamicWidget {...props} /> : <StaticWidget /> }
        </div>
    );
};

export default PayPalWidget;
